import { IonButton, IonSpinner } from "@ionic/react";
import Box from "@mui/material/Box";
import { DataGrid , deDE } from "@mui/x-data-grid";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../contexts/app_context";
import './table_geraete_grid.css';
import { useUnterweisungsthemen } from "./_CustomHooks";
import { ButtonAdd , ButtonInaktive , defColumn , exportTableData , getLoadErr } from './_HelperFunctions' ;

function UnterweisungsthemenTable() {
  const { appKundeId , appUnterweisungsthemenFetchstate , appUnterweisungsthemen , appUnterweisungsthemaIdChange , appViewSwitchChange } = useContext( AppContext ) ;
  const history = useHistory();
  const [pageSize, setPageSize] = useState(50);
  const [ localUnterweisungsthemen , localUnterweisungsthemenChange ] = useState( Array() ) ;
  const [ existInaktive , setExistInaktive ] = useState( false ) ;
  const [ showInaktive , setShowInaktive ] = useState( false ) ;
  const setColumns = ( tablePurpose:string ):any => {
    if( tablePurpose === 'Unterweisungsthemen' ) {
      return (
        [
          defColumn( 'UnterweisungsthemenId' , 'ID' , 0 ) ,
          defColumn( 'UnterweisungsthemenTitel' , 'Thema' , 300 ) ,
          defColumn( 'UnterweisungsthemenAktiv' , 'aktiv' , 80 , 0 ) ,
          defColumn( 'UnterweisungsthemenPflicht' , 'Pflicht' , 80 , 0 ) ,
          {
            field: "UnterweisungsthemenTurnus",
            headerName: "Turnus",
            headerClassName: "super-app-theme--header",
            minWidth: 200 ,
            flex: 0 ,
            renderCell: ( params:any ) => {
              if ( params.row.UnterweisungsthemenTurnus === "0" ) {
                return 'nicht festgelegt'
              }
              if ( params.row.UnterweisungsthemenTurnus === "1" ) {
                return 'Erstunterweisung'
              }
              if ( params.row.UnterweisungsthemenTurnus === "90" ) {
                return 'vierteljährlich'
              }
              if ( params.row.UnterweisungsthemenTurnus === "180" ) {
                return 'halbjährlich'
              }
              if ( params.row.UnterweisungsthemenTurnus === "365" ) {
                return 'jährlich'
              }
              if ( params.row.UnterweisungsthemenTurnus === "730" ) {
                return 'zwei Jahre'
              }
            }
          } ,
        ]
      )
    }
  }
  useUnterweisungsthemen() ;

  const handleInaktive = () =>
    {
      if( showInaktive ) {
        localUnterweisungsthemenChange( appUnterweisungsthemen )
      }
      else {
        localUnterweisungsthemenChange(
          appUnterweisungsthemen
            .filter(
              ( entry:any ) => entry.UnterweisungsthemenAktiv === 'aktiv'
            )        
        )
      }
    }

    useEffect(
      () => {
        if( appUnterweisungsthemen
            .findIndex(
              ( entry:any ) => entry.UnterweisungsthemenAktiv !== 'aktiv'
            ) > -1
        )
          {
            setExistInaktive( true )
          }
        else
          {
            setExistInaktive( false )
          }
        handleInaktive() ;
      } ,
      [ appUnterweisungsthemen ]
    )
    
    useEffect(
      () => {
        handleInaktive() ;
      } ,
      [ showInaktive ]
    )
    
    const mkTable = ( tablePurpose:string , singleGUI:string ) =>  {
    return (
      <Box
        sx={{
          height: 600,
          width: 1,
          "& .super-app-theme--header": {
            backgroundColor: "rgb(211,211,211)",
          },
        }}
      >
        {
          appUnterweisungsthemenFetchstate !== 200 && appUnterweisungsthemenFetchstate !== 204 ?
          (
            appUnterweisungsthemenFetchstate === 100
              ? <IonSpinner name="bubbles" />
              : <div style={{ margin: '30%' , opacity: '40%' , textAlign: 'center' }}>
                  { getLoadErr( appUnterweisungsthemenFetchstate ) }
                </div> 
          ) : (
            <>
              <DataGrid
                componentsProps = {{
                  toolbar: {
                    tablePurpose: tablePurpose
                  }
                }}
                initialState={{
                  sorting: {
                    sortModel: [ { field: 'UnterweisungsthemenTitel' , sort: 'asc' } ] ,
                  },
                }}
                getRowId={(row:any) => row.UnterweisungsthemenId} 
                getRowClassName =
                  {
                    ( data:any ) => data.row.UnterweisungsthemenAktiv !== 'aktiv' ? 'eintrag_inaktiv' : ''
                  }
                rows={localUnterweisungsthemen}
                columns={ setColumns( tablePurpose ) } 
                disableVirtualization 
                rowsPerPageOptions={[50,100]}
                disableSelectionOnClick
                sortingOrder={["desc", "asc"]}
                onCellClick = {
                  ( e ) =>
                    {
                      appViewSwitchChange( true ) ;
                      appUnterweisungsthemaIdChange( e.id ) ; 
                      history.push( '/' + singleGUI + '/' + e.id + '/' + appKundeId ) ;
                    }
                }
                // checkboxSelection
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
                //onCellClick={(e) => tryme(e.row)}
                // rowsPerPageOptions={[5, 10, 20]}
                pagination
                localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
              />
              <ButtonInaktive
                disabled = { existInaktive ? false : true }
                myExec = {
                  () =>
                    {
                      setShowInaktive( showInaktive ? false : true )
                    }
                  }
                label = { showInaktive ? 'Inaktive ausblenden' : 'Inaktive anzeigen' }
              />
              <ButtonAdd
                myExec = { () => { appUnterweisungsthemaIdChange( 'neu' ) ; } }
                routeUrl = { '/' + singleGUI + '/neu/' + appKundeId }
              />
              {
                localUnterweisungsthemen.length > 0
                  ?
                    <IonButton onClick={ () => exportTableData( localUnterweisungsthemen , 'Unterweisungsthemen' ) }>Exportieren</IonButton>
                  :
                    ''
              }
              {
                showInaktive
                  ?
                    <p style = { { fontSize: '0.8em' , fontWeight: 'bold' , marginLeft: '0.5em' , marginTop: '0' } } >
                      Inaktive Themen sind <span className = "eintrag_inaktiv">hellgrau</span> markiert
                    </p>
                  :
                    ''
              }
            </>
          )
        }
      </Box>
    )
  }
  return (
    <>
      { mkTable( 'Unterweisungsthemen' , 'unterweisungsthema' ) }
    </>
  );
}
export default UnterweisungsthemenTable;
